import * as React from 'react'
import { CalendarMonthOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { MobileDatePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { USER_ROLES } from '../../../utils/constants'

export default function CustomDatePicker({
  date,
  setDate,
  isdisabledYear,
}) {
  const [open, setOpen] = React.useState(false)
  const user = useSelector((state) => state.user)

  const isEmployeeWithRestriction =
    isdisabledYear && user.data.role === USER_ROLES.employee

  const handleClick = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <MobileDatePicker
      value={date.toDate()}
      open={open}
      onClose={handleClose}
      showToolbar={false}
      disableOpenPicker
      views={['year', 'month', 'day']}

      /** 👇 KEY LINE */
      minDate={
        isEmployeeWithRestriction
          ? moment().startOf('year').toDate()
          : undefined
      }

      onChange={(momentObj) => {
        setDate(momentObj)
        handleClose()
      }}
      renderInput={() => (
        <IconButton onClick={handleClick}>
          <CalendarMonthOutlined />
        </IconButton>
      )}
    />
  )
}
